import styled from '@emotion/styled';
import { withTheme } from '@mui/styles';

const Percentage = withTheme(styled.div`
  width: 100%;
  border: 2px solid white;
  height: 40px;
  margin: 10px 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  position: relative;
  background-color: white;
  z-index: 1;
  &:after {
    content: '';
    position: absolute;
    background: ${(props) => props.theme.palette.background.default};
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    top: 0;
    bottom: 0;
    left: 0;
    width: ${(p) => p.percentage}%;
  }

  @media (max-width: 900px) {
    width: 100%;
  }

  box-shadow: 3px 3px 3px #000;
`);

export default Percentage;
